// Single source of truth for role-based colour styling across the dashboard.
// Used by RoleBadge, UserEmail, and the role-count tiles on the main dashboard.
// Keep these in sync with the Cognito groups defined in auth-stack.ts.

export const ROLE_LABELS: Record<string, string> = {
  enumerator: 'Enumerator',
  transcriber: 'Transcriber',
  supervisor: 'Supervisor',
  'sub-admin': 'Sub-Admin',
  admin: 'Admin',
};

export const ROLE_COLOR_CLASSES: Record<string, string> = {
  enumerator: 'bg-gray-200 text-gray-800',
  transcriber: 'bg-sky-100 text-sky-800',
  supervisor: 'bg-purple-700 text-white',
  'sub-admin': 'bg-indigo-700 text-white',
  admin: 'bg-red-600 text-white',
};

export function roleColorClasses(role: string | undefined | null): string {
  return ROLE_COLOR_CLASSES[role ?? ''] ?? 'bg-gray-100 text-gray-600';
}

export function roleLabel(role: string | undefined | null): string {
  return ROLE_LABELS[role ?? ''] ?? (role ?? '—');
}
